<div class="drawer">
  <header class="drawer-header">
    <span class="drawer-title">{{ configs[currentMode].title }}</span>
    <button type="button" class="drawer-close" (click)="cancel()" aria-label="Close">×</button>
  </header>

  <div class="drawer-body">
    <div class="row two-col">
      <app-titled-input [control]="name" [title]="'Account name'">
        <ng-content>
          <input type="text" [formControl]="name" (blur)="onNameBlur()">
        </ng-content>
      </app-titled-input>
      <app-titled-input [control]="key" [title]="'Account key'">
        <ng-content>
          <input type="text" [formControl]="key">
        </ng-content>
        <div inputNote class="input-note" *ngIf="suggestedKey()">
          The account name was changed.
          <button type="button" class="input-note-action" (click)="refreshKey()">Click here</button>
          to refresh the account key
        </div>
      </app-titled-input>
    </div>

    <div class="select-menu-input-wrapper">
      <app-titled-input [control]="brands" [title]="'Brands'"></app-titled-input>
      <app-select-menu [items]="brandOptions()" [placeholder]="'Select brand'" [searchable]="true" [control]="brands"
        [selectMode]="SelectMode.MULTI" [selectAllAndClearOptions]="true" [virtualScroll]="true"
        appendTo="body" dropDownPosition="auto"></app-select-menu>
    </div>

    <div class="account-users-container" *ngIf="FormMode.EDIT === currentMode">
      <label>Users</label>
      <div class="users-list-container">{{ accountUsers?.join(', ') }}</div>
    </div>

    <div class="subscription-section" *ngIf="FormMode.EDIT === currentMode && subscriptionStatus()">
      <label>Subscription</label>
      <div class="subscription-row">
        <span class="subscription-chip" [ngClass]="subscriptionChipClass">{{ subscriptionChipLabel }}</span>
        <div class="trial-end-field">
          <span class="trial-end-label">Trial ends</span>
          <input type="date" [formControl]="trialEnd" [min]="minTrialEndDate" [class.disabled]="isBusy">
        </div>
        <app-button *ngIf="canConvert && canEditSubscription" (clicked)="convertToActive()" [class]="isBusy ? 'cancel disabled' : 'cancel'" text="Convert to Active"></app-button>
      </div>
      <div class="subscription-error" *ngIf="trialEnd.invalid">
        {{ trialEnd.errors?.['trialEndCleared']
          ? 'A trial end date is required — pick a new date instead of clearing it.'
          : 'The trial end date must be in the future.' }}
      </div>
    </div>
  </div>

  <footer class="drawer-footer">
    <app-button *ngIf="currentMode === FormMode.EDIT && canDelete" (clicked)="deleteAccount()"
      class="danger delete-account-button" text="Delete account"></app-button>
    <app-button (clicked)="cancel()" class="cancel" text="cancel"></app-button>
    <app-button (clicked)="submit()" [class]="form.invalid || saving() ? 'primary disabled' : 'primary'"
      [text]="configs[currentMode].submitText"></app-button>
  </footer>

  <app-loader *ngIf="saving()"></app-loader>
</div>
